import styled from 'react-emotion';

export const Element = styled('button')`
  padding: 18px 23px;
  border: 1px solid var(--grey-4);
  border-radius: 8px;
  background: transparent;
  font: bold 14px Montserrat, sans-serif;
  text-transform: uppercase;
  letter-spacing: 2px;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/components/Button/button.theme.js